export class UnidadFuncionalTipoRelacion {
    constructor(
      public readonly Id: number,
      public readonly Codigo: string | null,
      public readonly Nombre: string | null,
      public Activo: boolean
    ) {}
  }
  
  export class SearchUnidadFuncionalTipoRelacionRequest {
    constructor(
      public readonly PageSize: number | null,
      public readonly PageNumber: number | null,
      public readonly OrderAscending: boolean | null,
      public readonly OrderFieldName: string | null,
      public readonly Nombre: string | null,
      public readonly Codigo: string | null,
      //public readonly RolId: number | null,
      public readonly VerSoloActivos: boolean | null
    ) {}
  }
  
  export class SaveUnidadFuncionalTipoRelacionDto {
    constructor(
      public Nombre: string | null,
      public Codigo: string | null,
      public Activo: boolean
    ) {}
  }
  
  export class SearchUnidadFuncionalTipoRelacionResponse {
    constructor(
      public readonly count: number,
      public readonly result: UnidadFuncionalTipoRelacion[]
    ) {}
  }
  